import { el } from "../../utils/dom.js";
import { store } from "../../state/store.js";
import { renderDetailsRow } from "./detailsRow.js";
import { getIntermediateFrequencyMHz, getPolBandLabel } from "../../utils/sat.js";
import { getBitrateRowTitle, isHighBitrateTp } from "../../utils/bitrate.js";
import { appendButton, appendCell } from "../../utils/render.js";

export function renderSelectionTable() {
  const tbody = el("selTbody");
  if (!tbody) return;
  tbody.innerHTML = "";

  for (const [key] of store.selection) {
    const tp = store.tpByKey.get(key);
    if (!tp) continue;
    const isOpen = store.openDetails.has(key);
    const star = store.starred.has(key);
    const highBitrate = isHighBitrateTp(tp);

    const tr = document.createElement("tr");
    if (highBitrate) {
      tr.classList.add("high-bitrate");
      tr.title = getBitrateRowTitle(tp);
    }

    appendCell(tr, tp.tp_name || tp.provider || key, { title: tp.tp_name || "" });

    const detailsCell = appendCell(tr, "", { className: "nowrap" });
    appendButton(detailsCell, {
      label: `${isOpen ? "▾" : "▸"} Details`,
      dataset: { act: "toggle_details", key },
    });

    appendCell(tr, tp.sat_pos || "", { className: "nowrap" });
    appendCell(tr, tp.frequency_MHz || "", { className: "nowrap" });
    appendCell(tr, getIntermediateFrequencyMHz(tp.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, getPolBandLabel(tp.pol, tp.frequency_MHz) || "", { className: "nowrap" });
    appendCell(tr, tp.symbolrate_kSps || "", { className: "nowrap" });
    appendCell(tr, tp.dvb || "", { className: "nowrap" });
    appendCell(tr, tp.tsid_onid || (tp.tsid ? `${tp.tsid}/${tp.onid || ""}` : ""), { className: "nowrap" });
    appendCell(tr, (store.programsByTpKey.get(key) || []).length, { className: "nowrap" });

    const actionsCell = appendCell(tr, "", { className: "nowrap" });
    const actions = document.createElement("div");
    actions.className = "actions";
    actionsCell.appendChild(actions);

    appendButton(actions, {
      label: "✓",
      className: "primary",
      dataset: { act: "remove", key },
    });
    appendButton(actions, {
      label: star ? "★" : "☆",
      title: "Favorit",
      dataset: { act: "toggle_star", key },
    });

    tbody.appendChild(tr);
    if (isOpen) tbody.appendChild(renderDetailsRow(key, 11));
  }

  if (store.selection.size === 0) {
    const tr = document.createElement("tr");
    appendCell(tr, "Keine Transponder ausgewaehlt.", {
      className: "muted",
      colSpan: 11,
    });
    tbody.appendChild(tr);
  }

  const n = store.selection.size;
  const exportBtn = el("exportBtn");
  const clearBtn = el("clearSelBtn");
  if (exportBtn) exportBtn.disabled = n === 0;
  if (clearBtn) clearBtn.disabled = n === 0;

  const c1 = el("selCountBtn");
  const c2 = el("selCountBtn2");
  if (c1) c1.textContent = String(n);
  if (c2) c2.textContent = String(n);
  const tabSel = el("tabSelCount");
  if (tabSel) tabSel.textContent = String(n);
  const head = el("selCountHeader");
  if (head) head.textContent = String(n);
}
